import api from "@/lib/api";

const H = () => {
  const v = typeof document !== "undefined"
    ? document.cookie.split(";").map(c => c.trim()).find(c => c.startsWith("active_hotel_id="))
    : null;
  return v ? { headers: { "X-Hocp-Hotel": decodeURIComponent(v.split("=")[1]) } } : {};
};

export const v2API = {
  roleTemplates:      ()          => api.get("/wf/v2/role-templates", H()).then(r=>r.data),
  seedRoleTemplates:  ()          => api.post("/wf/v2/role-templates/seed", {}, H()).then(r=>r.data),
  systemAccess:       ()          => api.get("/wf/v2/system-access", H()).then(r=>r.data),
  grantAccess:        (uid, body) => api.post(`/wf/v2/identity/${uid}/grant`, body, H()).then(r=>r.data),
  activate:           (uid)       => api.post(`/wf/v2/identity/${uid}/activate`, {}, H()).then(r=>r.data),
  disable:            (uid)       => api.post(`/wf/v2/identity/${uid}/disable`, {}, H()).then(r=>r.data),
  unlock:             (uid)       => api.post(`/wf/v2/identity/${uid}/unlock`, {}, H()).then(r=>r.data),
  resetPassword:      (uid, body) => api.post(`/wf/v2/identity/${uid}/reset-password`, body, H()).then(r=>r.data),
  changeRole:         (uid, tplId)=> api.post(`/wf/v2/identity/${uid}/change-role`, { role_template_id: tplId }, H()).then(r=>r.data),
  copyAccess:         (uid, srcId)=> api.post(`/wf/v2/identity/${uid}/copy-access`, { source_user_id: srcId }, H()).then(r=>r.data),
  removeAccess:       (uid)       => api.post(`/wf/v2/identity/${uid}/remove-access`, {}, H()).then(r=>r.data),
};
